import { render, staticRenderFns } from "./Timepiece.vue?vue&type=template&id=433112b7&lang=pug&"
import script from "./Timepiece.vue?vue&type=script&lang=js&"
export * from "./Timepiece.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports